import * as Yup from 'yup';
import { exceedsStripeMaxAmount, STRIPE_MAX_AMOUNT } from '@repo/lib';
import { formatPrice, formatPriceInput } from '@dashboard/services/formatting';

// The field is in major units; checked the way submit converts it, so the cap matches what the API gets.
export const amountOffValidation = Yup.number()
  .nullable()
  .when('discountType', {
    is: 'amountOff',
    then: Yup.number()
      .moreThan(0, 'Must be greater than 0')
      .test('stripe-max-amount', function (value) {
        const { currency } = this.parent;
        if (!exceedsStripeMaxAmount(formatPriceInput(value, currency))) return true;
        return this.createError({
          message: `Cannot exceed ${formatPrice({ amount: STRIPE_MAX_AMOUNT, currency })}`,
        });
      })
      .required('Must be greater than 0')
      .typeError('Must be greater than 0'),
  });
